import React, { useEffect, useState } from 'react'
import Loading from 'react-fullscreen-loading'
import { SD_CAPITALIZE } from '../../../includes/staticData';
import * as CONST from "../../../includes/Constant";
import { toast } from 'react-toastify';
import axios from 'axios';
import Select from 'react-select';
import Form from "../../../includes/Forms";
import useAuthInfo from '../../../../hooks/IsAdmin';

export default function UpdateInvoiceProject({ client_id, project_id, invoice_id, invoice_data }) {
  const { isAdmin, eDepartmentId, eUser_id } = useAuthInfo();
  const [loading, setLoading] = useState(true);
  const [arrProjects, setArrProjects] = useState([]);
  const [project, setProject] = useState([]);
  const [validate, setValidate] = useState(false);
  const fetchClientProjects = async () => {
    setLoading(true);
    try {
      const response = await axios.post(CONST.GET_CLIENT_PROJECTS, { cid: client_id });
      if (response.data.status === 'success') {
        setArrProjects(response.data.data.map(project => ({ value: project.id, label: project.name })));
      }
    } catch (error) {
      toast.error('Error fetching projects:', error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchClientProjects();
  }, []);

  const validateForm = async () => {
    let isValid = true;
    let errors = {};
    const validator = Form.validator({
      new_project_name: {
        value: project,
        isRequired: true,
        label: "project name",
      },

    });

    if (validator && validator.errors) {
      errors = { ...errors, ...validator.errors };
      isValid = false;
    }

    setValidate({
      validate: errors,
    });

    return isValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = await validateForm();
    if (!isValid) return;
    setLoading(true);
    try {
      setLoading(true);
      const response = await axios.post(CONST.UPDATE_INVOICE_PROJECT, {
        invoice_id: invoice_id,
        project_id: project?.value,
        added_by: eUser_id,
        old_project_name: invoice_data?.project_name || "-",
        new_project_name:  project?.label,

      });
      if (response) {
        if (response.data.status === "success") {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      {loading && <Loading loading={loading} />}
      <div className="row mb-3">
        <form onSubmit={handleSubmit}>
          <div className="col-md-6 col-sm-12 ">
            <label className="form-label text-muted">Current Project Name</label>
            <p>{SD_CAPITALIZE(invoice_data?.project_name || "-")}</p>
          </div>
          <div className="col-md-6 col-sm-12">
            <label className="form-label text-muted">Update Project Name</label>
            <p>
              <Select
                placeholder="Select a project..."
                options={arrProjects}
                onChange={setProject}
                value={project}
                name='new_project_name'
                className={`react-select-container  ${validate.validate && validate.validate.new_project_name ? "is-invalid" : ""
                  }`}
              />
              {validate.validate && validate.validate.new_project_name && (
                <div className="invalid-feedback">
                  {validate.validate && validate.validate.new_project_name}
                </div>
              )}
            </p>
          </div>
          <div className="col-md-12 text-right">
            <button type="submit" className="btn btn-primary">
              Update
            </button>
          </div>
        </form>
      </div>
    </>
  )
}
